import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';


@Injectable({
  providedIn: 'root'
})
export class ComponentsTemplatesService {

  constructor(private httpClient: HttpClient) { }

  getAllTemplates(data){
    return this.httpClient.post("/PredefinedTemplates/GetAllSettings",data)
  }
  addTemplate(data){
    return this.httpClient.post("/PredefinedTemplates/CreateSetting",data)
  }
  deleteTemplate(id){
    return this.httpClient.delete(`/PredefinedTemplates/DeleteSetting/${id}`)
  }
  updateTemplate(data){
    return this.httpClient.put(`/PredefinedTemplates/UpdateSetting`,data)
  }
  getAllComponents(){
    return this.httpClient.get("/Components/GetAllComponents")
  }
  uploadMedia(data){
    return this.httpClient.post("/media/UploadSystemMedia",data)
  }
}
